import { useEffect } from 'react';
import * as Sentry from '@sentry/react';
import { useLazyGetUsersMeQuery } from '@/services';
import { useAuth } from '@/contexts/auth-context';

export const SentryObserver = () => {
  const { isAuthenticated } = useAuth();
  const [fetchCurrentUser] = useLazyGetUsersMeQuery();

  useEffect(() => {
    const fetchUser = async () => {
      if (isAuthenticated) {
        try {
          const { success, data: user } = await fetchCurrentUser().unwrap();
          if (success && user) {
            Sentry.setUser({ email: user.email ?? undefined, id: user.id });
          } else {
            Sentry.setUser(null);
          }
        } catch (error) {
          Sentry.setUser(null);
          Sentry.captureException(error);
        }
      } else {
        Sentry.setUser(null);
      }
    };
    fetchUser();
  }, [isAuthenticated, fetchCurrentUser]);

  return null;
};
